module.exports = __webpack_public_path__ + "img/AT0000002474136.3decaee6.png";